<a class="skip-link" href="#main-content">Saltar al contenido principal</a>

<app-header></app-header>

<!-- Contenido principal de la aplicación -->
<main class="main-content" id="main-content" tabindex="-1">
  <router-outlet></router-outlet>
</main>

<p class="global-disclaimer">
  Los datos e información publicados son de carácter provisorio y pueden estar sujetos a revisión. La EEAOC no
  asume responsabilidad por su uso, interpretación o aplicación.
  <!-- Aviso de privacidad por Google Analytics (ver services/analytics.service.ts) -->
  <span class="global-disclaimer__privacidad">
    Este sitio usa Google Analytics para conocer de forma anónima cómo se usa (páginas visitadas, tipo de
    dispositivo y ubicación aproximada), con el único fin de mejorarlo.
    <a routerLink="/privacidad">Política de privacidad</a>
  </span>
</p>

<app-footer></app-footer>